import { StateContext, Store } from "@ngxs/store";

import { AddItineraryResponse, validateResponse } from "@hiptraveler/data-access/api";
import { ItineraryStateModel } from "..";
import { setActiveNavbarButtons, addUserItineraryByAddItineraryResponse } from ".";
import { getWindowRef, globalStateManagementStoreKey, isWidget, NavbarControlStateService } from "@hiptraveler/common";

export function addItinerary({ ctx, response, navbarControl, numDays }: {
  ctx: StateContext<ItineraryStateModel>, response: AddItineraryResponse,
  navbarControl: NavbarControlStateService, numDays: number
}): void {

  const store: Store = getWindowRef()[globalStateManagementStoreKey];

  addUserItineraryByAddItineraryResponse(store, response, numDays);

  if (isWidget()) {
    return validateResponse(response, { ignoreKey: 'itiMap' });
  }

  if (!response?.data?.itiMap?.basicInfo) {
    const defaultErrorMessage = 'Something went wrong. Please try again.';
    throw { error: response?.data?.error || defaultErrorMessage };
  }

  setActiveNavbarButtons(response, navbarControl);

  const basicInfo = response.data.itiMap.basicInfo;
  ctx.patchState({ basicInfo });
}
